module.exports = __webpack_public_path__ + "img/eternal_shroud.d7dd9c84.png";